import { createFileRoute } from "@tanstack/react-router";
import WorkspaceAiUsagePage from "@/features/workspaces/workspace-ai-usage.page";

export const Route = createFileRoute("/_authenticated/workspaces/$slug/ai-usage" as const)({
  component: WorkspaceAiUsagePage,
});
